/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  useCallback,
  useMemo,
  useState,
  useRef,
  useEffect,
} from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";
import { isProduction } from "src/config/index";
import PropTypes from "prop-types";
// import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import FormikCreateSearchClear from "src/components/formik/FormikCreateSearchClear";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import Table from "src/components/table/Table";
import { set } from "lodash";
import { getEndOfDay, getStartOfDay } from "src/utils/DadeUtils";
import {
  caseEditAction,
  caseResetAction,
  caseSearchAction,
} from "../case-container/actions/CaseActions";
import {
  excelCaseSearchAction,
} from "../excel-container/actions/ExcelActions";
import { headerShowAction } from "../header-container/actions/HeaderActions";
import RoutingUtil from "src/utils/RoutingUtil";
import OpenNewTabLink from "src/components/OpenNewTabLink";
import { userSearchAPI } from "src/api/UserApi";
import {
  PRODUCT_CATEGORY_TYPES_LIST,
  CAR_LOAN_TYPE_LIST,
  USED_CAR_LOAN_TYPE_LIST,
} from "../product-container/ProductConstants";
import CompanyDropDown from "src/business-components/CompanyDropDown";
import UserDropDown from "src/business-components/UserDropDown";
import CommissionManagerDropDown from "src/business-components/CommissionManagerDropDown";
import TargetManagerDropDown from "src/business-components/TargetManagerDropDown";
import FormikSelect from "src/components/formik/FormikSelect";
import { PAYOUT } from "../company-container/CompanyConstants";
import FormikCheckBox from "src/components/formik/FormikCheckBox";
import { caseInvoiceCreateAPI, caseSearchAPI, casesForExcelApi, pipelineApi } from "src/api/CaseApi";
import { companySearchAPI } from "src/api/CompanyApi";
import LinkComponent from "src/components/LinkComponent";
import { Route, Switch } from "react-router-dom";
import Invoice from "./Invoice";
import { useHistory } from "react-router";
import { commissionSearchAction } from "../commission-container/actions/CommissionActions";
import { commissionSearchAPI } from "src/api/CommissionApi";
import { EMPLOYMENT_TYPES_LIST } from "../user-container/UserConstants";
import { DATA_TYPE } from "src/constants/CommonConstants";
import { remarkSearchAPI } from "src/api/RemarkApi";
import { ExportReactCSV } from "src/components/excel/ExportReactCSV";
import FormikInput from "src/components/formik/FormikInput";
import { DATE_TIME_FORMAT } from "src/constants/CommonConstants";
import { PAYMENT_MODE_TYPES_LIST } from "../product-container/ProductConstants";
import PayRecPopup from "./PayRecPopup";
import ComissionPopup from "./ComissionPopup";
import CustomerDropDown from "src/business-components/CustomerDropDown";
import { targetSearchAPI } from "src/api/TargetApi";
import { walletSearchAction, walletUpsertAction } from "../wallet-container/actions/WalletActions";
import { walletPaymentCreateAPI, walletPaymentSearchAPI } from "src/api/WalletApi";

const RenderFilters = (props) => {
  // DEV TOOL
  if (!isProduction()) {
    withFormikDevtools(props);
  }

  const {
    // errors,
    // touched,
    isSubmitting,
    onClear,
    // forceRefreshSearchContainer,
    resetForm,
    values,
    activityList,
    userType,
    ExportInExcel,
    handleChange,
    generateInvoice,
    handleReceipt,
    handlePayment,
    history,
    onPageChange,
    alertModalClass,
    alertDisplay,
    openAlertDialog,
    closeAlertDialog,
    viewRemarks,
    viewComission,
    editClick,
    dueAmountModalClass,
    dueAmountDisplay,
    payoutModalClass,
    comissionModalClass,
    comissionDisplay,
    payoutDisplay,
    totalPayout,
    totalDueAmount,
    paid,
    netPaid,
    received,
    netReceived,
    grossLoan,
    netLoan,
    totalCheckedDue,
    invoiceInitialValues,
    totalCheckedPayOut,
    pendingDueList,
    pendingPayOutList,
    caseForViewComission,
    total,
    callFrom,
    handleSubmitUpdates,
    totalAdvanceAmount,
    remainingPayOut,
  } = props;

  // console.log("invoiceInitialValues=>", invoiceInitialValues);
  return (
    <div>
      <div style={{ justifyContent: "center", display: "flex", padding: "px" }}>
        <h2>Admin Car Loan Payout</h2>
      </div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Search Filters</h5>
          <Form>
            <div className="form-row">
              <div className="form-group col-md-3">
                <label>Category</label>
                {/* <FormikSelect
                  items={PRODUCT_CATEGORY_TYPES_LIST}
                  name="productCategory"
                  className="form-control"
                /> */}
                <Field
                  type="text"
                  className="form-control"
                  disabled
                  value="Car Loan"
                  name="productCategory"
                // initialValue="CAR_LOAN"
                />
              </div>
              {/* {values.productCategory === "CAR_LOAN" && ( */}
              <div className="form-group col-md-3">
                <label>Loan Type</label>
                <FormikSelect
                  items={CAR_LOAN_TYPE_LIST}
                  name="loanType"
                  className="form-control"
                  disabled={Boolean(values.FilterCommissionId) || Boolean(values.FilterTargetId)}
                />
              </div>
              {/* )} */}
              {/* {values.productCategory === "CAR_LOAN" && */}
              {values.loanType === "USED" && (
                <div className="form-group col-md-3">
                  <label>Used Car Loan Type</label>
                  <FormikSelect
                    items={USED_CAR_LOAN_TYPE_LIST}
                    name="usedCarLoanType"
                    className="form-control"
                  />
                </div>
              )}
              <div className="form-group col-md-3">
                <label>From Date</label>
                <FormikDateTimePicker
                  name="CaseFromDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={Boolean(values.FilterCommissionId) || Boolean(values.FilterTargetId)}
                />
              </div>
              <div className="form-group col-md-3">
                <label>To Date</label>
                <FormikDateTimePicker
                  name="CaseToDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={Boolean(values.FilterCommissionId) || Boolean(values.FilterTargetId)}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Company</label>
                <CompanyDropDown
                  name="companyId"
                  value={values.companyId}
                  disabled={(Boolean(values.FilterCommissionId) || Boolean(values.FilterTargetId))}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Assigned Agent</label>
                <UserDropDown name="agentId" value={values.agentId} disabled={Boolean(values.FilterTargetId)} />
              </div>
              <div className="form-group col-md-3">
                <label>Reporting Manager</label>
                <UserDropDown
                  name="reportingManagerId"
                  value={values.reportingManagerId}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Employment Type</label>
                <FormikSelect
                  items={EMPLOYMENT_TYPES_LIST}
                  name="employmentType"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-6">
                <label>Customer</label>
                <CustomerDropDown name="customerId" value={values.customerId} />
              </div>
              <div className="form-group col-md-3">
                <label>Commission</label>
                <CommissionManagerDropDown
                  name="FilterCommissionId"
                  value={values.FilterCommissionId}
                  placeholder="Default Comission"
                />
              </div>

              {values.FilterCommissionId ? (
                <div className="col-md-6">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Target</th>
                        <th scope="col">Reward</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Tillnow</th>
                        <th scope="col">Short Amount</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activityList.commissionDetails.map(
                        (commission, index) => {
                          return (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  commission.status == "Completed"
                                    ? "#81e381"
                                    : "#f1f16d",
                              }}
                            >
                              <td>{commission.commissionTarget}</td>
                              <td>
                                {commission.reward}
                                {commission.isRewardPercentage ? "%" : ""}
                              </td>
                              <td>{commission.status === "Completed" ? commission.amount: 0 }</td>
                              <td>{commission.tillNow}</td>
                              <td>{commission.short}</td>
                              <td>{commission.status}</td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              ) : null}

              <div className="form-group col-md-3">
                <label>Target</label>
                <TargetManagerDropDown
                  name="FilterTargetId"
                  value={values.FilterTargetId}
                  placeholder="Default Target"
                />
              </div>

              {values.FilterTargetId ? (
                <div className="col-md-6">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Target</th>
                        <th scope="col">Reward</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Tillnow</th>
                        <th scope="col">Short Amount</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activityList.agentWiseTargetDetails.map(
                        (target, index) => {
                          return (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  target.status == "Completed"
                                    ? "#81e381"
                                    : "#f1f16d",
                              }}  
                            >
                              <td>{target.name}</td>
                              <td>{target.targetGoal}</td>
                              <td>
                                {target.reward}
                                {target.isRewardPercentage ? "%" : ""}
                              </td>
                              <td>{target.amount}</td>
                              <td>{target.tillNow}</td>
                              <td>{target.short}</td>
                              <td>{target.status}</td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              ) : null}
            </div>
            <div className="text-center py-4 mt-3">
              <FormikCreateSearchClear
                isSubmitting={isSubmitting}
                onClear={onClear}
                resetForm={resetForm}
                submitButtonText="Search"
                submitScope="reports.payout_calculation.search"
              />
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                openAlertDialog("invoice");
              }}
            >
              Create Invoice
            </button>

            <button
              type="button"
              className="btn btn-primary mx-2"
              onClick={() => {
                openAlertDialog("dueAmount");
              }}
            >
              Receipt
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                openAlertDialog("Payout");
              }}
            >
              Payment
            </button>
          </Form>
        </div>
      </div>

      {/* invoice */}
      {/* <div className={`modal fade ${(invoiceModal) ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> */}
      <div
        className={`modal fade ${alertModalClass}`}
        id="authAlert"
        style={{
          display: `${alertDisplay}`,
          overflowY: "scroll",
          opacity: "1",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        {/* <div className="modal fade show" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" style={{ display: 'block', paddingRight: '5px' }} aria-modal="true" role="dialog"> */}
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Create Invoice
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeAlertDialog("invoice")}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group col-md-12">
                <label>Commission</label>
                <CommissionManagerDropDown
                  name="commissionId"
                  value={values.commissionId}
                  placeholder="Default Comission"
                />
              </div>
            </div>
            <div className="modal-body">
              <div className="form-group col-md-12">
                <label>Loan AC/Policy Number</label>
                <FormikInput
                  name="LoanPolicyNumber"
                  type="text"
                  placeholder="enter Loan A/C/Policy Number"
                  value={values.LoanPolicyNumber}
                  className="form-control"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeAlertDialog("invoice")}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  generateInvoice(values.commissionId);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Due amount */}
      <PayRecPopup
        type="rec"
        invoiceInitialValues={invoiceInitialValues}
        totalReceived={received}
        dueAmountModalClass={dueAmountModalClass}
        dueAmountDisplay={dueAmountDisplay}
        totalCheckedDue={totalCheckedDue}
        closeAlertDialog={closeAlertDialog}
        pendingAmountList={pendingDueList}
      />
      {/*  */}

      {/*  Payout */}
      <PayRecPopup
        type="pay"
        invoiceInitialValues={invoiceInitialValues}
        totalReceived={paid}
        dueAmountModalClass={dueAmountModalClass}
        dueAmountDisplay={payoutDisplay}
        totalCheckedDue={totalCheckedPayOut}
        closeAlertDialog={closeAlertDialog}
        pendingAmountList={pendingPayOutList}
        totalAdvanceAmount={totalAdvanceAmount}
        remainingPayOut={remainingPayOut}
        handleSubmitUpdates={handleSubmitUpdates}
      />
      {/*  */}
      {/*  ComissionPopup */}
      <ComissionPopup
        caseForViewComission={caseForViewComission}
        comissionModalClass={comissionModalClass}
        comissionDisplay={comissionDisplay}
        callFrom={callFrom}
        closeAlertDialog={closeAlertDialog}
      // defaultAmount= {}
      />
      {/*  */}

      <div className="border-top my-3" />

      <div className="card mt-3">
        <div className="card-body">
          <h5 className="card-title">
            Search Results
            <ExportReactCSV
              csvData={ExportInExcel}
              fileName={"Loan-Payout-Report-" + new Date().toLocaleDateString()}
            />
          </h5>

          <div className="mb-2 border p-2 float-left">
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Gross Loan Amount</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalGrossAmt || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Net Loan Amount</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalNetAmt || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Due(Pay IN) Amount</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalDueAmount || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Received</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalExistingAmountForDue || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Payout(Pay OUT) Amount</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalPayoutAmount || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Paid</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalExistingAmountForPayout || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
          </div>
          <Table
            recordsPerPage={50}
            onPageChange={onPageChange}
            searchData={{
              data: activityList.data,
              count: activityList.count,
              currentPage: activityList.currentPageIndex,
              //payoutAmt=agentcmsn*loanamt
            }}
            columns={{
              group: [
                {
                  display: "Loan Date",
                  type: Date,
                  path: "meta.loanDate",
                },
                {
                  display: "Loan Type",
                  path: "meta.loanType",
                },
                {
                  display: "Car Loan Type",
                  path: "meta.usedCarType",
                },
                {
                  display: "Loan A/c Number",
                  path: "meta.LoanAccountNo",
                },
                // {
                //   display: "Policy Number",
                //   path: "coverNotes.cn_number",
                // },
                {
                  display: "Loan Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.loanAmount",
                },
                {
                  display: "EMI Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.EMIAmount",
                },
                {
                  display: "Tenure",
                  path: "meta.tenure",
                },
                {
                  display: "ROI",
                  type: DATA_TYPE.Decimal,
                  path: "meta.businessIRR",
                },
                {
                  display: "Processing Fees",
                  type: DATA_TYPE.Decimal,
                  path: "meta.processingFees",
                },
                {
                  display: "Disbursed Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.disbursedAmount",
                },
                {
                  display: "Dealer/Showroom",
                  path: "meta.showroomDealer.companyDisplayName",
                },
                {
                  display: "first EMI",
                  path: "meta.firstEMI",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                },
                {
                  display: "Last EMI Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "meta.LastEMIDate",
                },
                {
                  display: "Bank/Company Name",
                  path: "companyId.companyName",
                },
                {
                  display: "Name of Customer",
                  path: "customerName",
                },
                {
                  display: "Customer Mobile",
                  path: "customerId.phone",
                },
                {
                  display: "Brand Name",
                  path: "meta.vehicleProductId.manufacturer.companyName",
                },
                {
                  display: "Model Name",
                  path: "meta.vehicleProductId.productName",
                },
                {
                  display: "Cubic Capacity",
                  path: "meta.vehicleProductId.meta.cubicCapacity",
                },
                {
                  display: "Fuel Type",
                  path: "meta.vehicleProductId.meta.fuelType",
                },
                {
                  display: "Cost Of Asset",
                  type: DATA_TYPE.Decimal,
                  path: "meta.costOfAsset",
                },
                {
                  display: "Cross Sell Amount",
                  type: DATA_TYPE.Decimal,
                  path: "CrossSellAmount",
                },
                {
                  display: "Gross Loan Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.grossLoanAmount",
                },
                {
                  display: "Advance EMI",
                  type: DATA_TYPE.Decimal,
                  path: "meta.EMIAdvance",
                },
                {
                  display: "Vehicle Number",
                  path: "meta.vehicleNumber",
                },
                {
                  display: "Invoice Received",
                  path: "meta.invoiceRecv",
                },
                {
                  display: "RC Received",
                  path: "meta.RCRecv",
                },
                {
                  display: "Insurance Received",
                  path: "meta.insuranceRec",
                },
                {
                  display: "Parivahan Status",
                  path: "meta.parivahanStatus",
                },
                {
                  display: "RTO Slip Received",
                  path: "meta.rtoSlip",
                },
                {
                  display: "Reporting Manager Name",
                  path: [
                    "reportingManagerId.personalInfo.firstName",
                    "reportingManagerId.personalInfo.lastName",
                    "reportingManagerId.personalInfo.phone",
                  ],
                },
                {
                  display: "Assigned Agent Name",
                  path: "agentName",
                },
                {
                  display: "Created By",
                  path: "by.personalInfo.firstName",
                },
                {
                  display: "Day Count",
                  path: "dayCount",
                },
                {
                  display: "Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "ts",
                },
                // {
                //   display: "Payment Amount",
                //   path: "paymentAmount",
                // },
                // {
                //   display: "Receipt Amount",
                //   path: "receiptAmount",
                // },

                {
                  display: "Amount",
                  type: DATA_TYPE.Decimal,
                  path: "amount",
                },
                {
                  display: "Bank Payment Rate(%)",
                  type: DATA_TYPE.Decimal,
                  path: "companyCommissionPercentage",
                },
                {
                  display: "Due Amount",
                  type: DATA_TYPE.Decimal,
                  path: "DueAmount",
                  onClick: (record) => viewComission(record._id, "receivedFromBank")
                },
                {
                  display: "Received Amount",
                  type: DATA_TYPE.Decimal,
                  path: "receiptAmount",
                },
                {
                  display: "GST(Inc/Exc)",
                  path: "GSTEncExc",
                },
                {
                  display: "Total Due Amount (Inc/Exc GST)",
                  type: DATA_TYPE.Decimal,
                  path: "totalDuewithGST",
                },
                {
                  display: "Agent Payout Rate(%)",
                  type: DATA_TYPE.Decimal,
                  path: "agentCommissionPercentage",
                },
                {
                  display: "Payout Amount",
                  type: DATA_TYPE.Decimal,
                  path: "payoutAmount",
                  onClick: (record) => viewComission(record._id, "payedToAgent")
                },
                {
                  display: "Paid Amount",
                  type: DATA_TYPE.Decimal,
                  path: "paymentAmount",
                },
                {
                  display: "Disbursement Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "meta.loanDate",
                },

                {
                  display: "Saving",
                  type: DATA_TYPE.Decimal,
                  path: "difference",
                },
              ],
            }}
            rowColoring={[
              // list should be priority wise
              {
                reason: "Pending",
                rowClass: "status-pending",
                shouldApply: (record) => record.isPending,
              },
              {
                reason: "Critical",
                rowClass: "status-critical",
                shouldApply: (record) => record.isCritical,
              },
            ]}
            customActions={[
              {
                heading: "Check For Select",
                // eslint-disable-next-line react/prop-types
                Render: ({ record }) => {
                  return (
                    // <PermissionHOC
                    //     scope="mis.case_mis.case_report"
                    // >
                    //     <OpenNewTabLink
                    //         url={RoutingUtil.caseActivityReport(record.caseInfo._id)}
                    //         title={record.caseInfo.caseDetails.caseCode}
                    //     />
                    // </PermissionHOC>
                    <>
                      <FormikCheckBox
                        className="ml-2 big-checkbox"
                        name={`${record._id}`}
                        value={record._id}
                        checked={true}
                        // data-payment={`${record.payOut}`}
                        // data-receipt={`${record.receipt}`}
                        data-due={`${record.DueAmount}`}
                        data-payout={`${record.payoutAmount}`}
                        data-paid={`${record.paymentAmount}`}
                        data-received={`${record.receiptAmount}`}
                        data-agentid={`${record.agentId._id}`}
                        data-casecode={`${record.caseCode}`}
                        onClick={handleChange}
                      />
                    </>
                  );
                },
              },

              {
                heading: "View Invoice",
                Render: ({ record }) => {
                  return (
                    <LinkComponent
                      onClick={() => history.push(`/invoice/${record._id}`)}
                    >
                      <i className="fas fa-eye" />
                    </LinkComponent>
                  );
                },
              },
              {
                heading: "Bank Receipts",
                Render: ({ record }) => {
                  return (
                    <LinkComponent
                      onClick={() => history.push(`/receipt/${record._id}`)}
                    >
                      <i className="fas fa-eye" />
                    </LinkComponent>
                  );
                },
              },
              {
                heading: "Agent Payments",
                Render: ({ record }) => {
                  return (
                    <LinkComponent
                      onClick={() => history.push(`/payment/${record._id}`)}
                    >
                      <i className="fas fa-eye" />
                    </LinkComponent>
                  );
                },
              },
              {
                heading: "View Remarks",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => viewRemarks(record._id)}>
                      <i className="fas fa-eye " />
                    </LinkComponent>
                  );
                },
              },
              {
                heading: "View Comission",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => viewComission(record._id, 'receivedFromBank')}>
                      <i className="fas fa-eye " />
                    </LinkComponent>
                  );
                },
              },
              {
                heading: "View Case Manager",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => editClick(record)}>
                      <i className="fas fa-pen" />
                    </LinkComponent>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

RenderFilters.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  // activityList: PropTypes.Object.isRequired,
};

// setting submit button state after submitting
const filterDefaultValues = {
  verifierId: "",
  clientId: "",
  branchId: "",
  CaseFromDate: null, //new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  CaseToDate: null, //new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  caseId: "",
  caseStatus: "",
  overAllcaseStatus: "",
  LoanPolicyNumber: "",
  PaymentDue: 0,
  ReceiptDue: 0,
};

const RptCaseStatus = () => {
  const [filterInitialValues, setFilterInitialValues] = useState({
    ...filterDefaultValues,
  });

  const [currentProductCategory, setProductCategory] = useState();

  const [currentCompany, setCurrentCompany] = useState();

  const [currentActivityAssignedDateTill, setCurrentActivityAssignedDateTill] =
    useState();

  const [currentActivityAssignedDateFrom, setCurrentActivityAssignedDateFrom] =
    useState();

  const [invoiceInitialValues, setInvoiceInitialValues] = useState([]);
  const [receiptValues, setReceiptValues] = useState([]);
  const [pendingPayOutList, setPendingPayOutList] = useState([]);
  const [pendingDueList, setPendingDueList] = useState([]);

  const [where, setWhere] = useState({});

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const [alertModalClass, setAlertModalClass] = useState(false);
  const [alertDisplay, setAlertDisplay] = useState(false);
  const [dueAmountModalClass, setDueAmountModalClass] = useState(false);
  const [dueAmountDisplay, setDueAmountDisplay] = useState(false);
  const [payoutModalClass, setPayoutsModalClass] = useState(false);
  const [payoutDisplay, setPayoutDisplay] = useState(false);
  const [remarksModalClass, setRemarksModalClass] = useState(false);
  const [remarksDisplay, setRemarksDisplay] = useState(false);
  const [remarksDetails, setRemarksDetails] = useState([]);

  const [commissionMaster, setCommissionMaster] = useState({ slab: [] });
  const [targetMaster, setTargetMaster] = useState({ slab: [] });
  const [totalPayout, setTotalPayout] = useState(0);
  const [totalDueAmount, setTotalDueAmount] = useState(0);
  const [netPaid, setNetPaid] = useState(0);
  const [paid, setPaid] = useState(0);
  const [netReceived, setTotalReceived] = useState(0);
  const [received, setReceived] = useState(0);
  const [grossLoan, setGrossLoan] = useState(0);
  const [netLoan, setNetLoan] = useState(0);
  const [totalCheckedPayOut, setTotalCheckedPayOut] = useState(0);
  const [totalCheckedDue, setTotalCheckedDue] = useState(0);
  const [comissionDisplay, setComissionDisplay] = useState(false)
  const [callFrom, setCallFrom] = useState("receivedFromBank")
  const [comissionModalClass, setComissionModalClass] = useState(false);
  const [caseForViewComission, setCaseForViewComission] = useState(false);
  const [total, setTotal] = useState({})
  const [agentLoanSumList, setAgentLoanSumList] = useState([])
  //
  const [totalAdvanceAmount, setTotalAdvanceAmount] = useState(0);
  const [remainingPayOut, setRemainingPayOut] = useState(0);
  const [agentIdForAdvance, setAgentIdForAdvance] = useState(null);
  const [caseCodeForAdvance, setCaseCodeForAdvance] = useState(null);
  const openAlertDialog = (type, callFromDueOrPay) => {
    if (type === "invoice") {
      setAlertDisplay("block");
      setAlertModalClass("show");
    } else if (type === "remarks") {
      setRemarksDisplay("block");
      setRemarksModalClass("show");
    } else if (type === "dueAmount") {
      setDueAmountDisplay("block");
      setDueAmountModalClass("show");
    } else if (type === "Payout") {
      setPayoutDisplay("block");
      setPayoutsModalClass("show");
    } else if (type === "Comission") {
      setComissionDisplay("block");
      setComissionModalClass("show");
      setCallFrom(callFromDueOrPay);
    }

    if (document.body.style.overflow !== "hidden") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  };
  const closeAlertDialog = (type) => {
    if (type === "invoice") {
      setAlertModalClass("none");
      setAlertDisplay("");
    } else if (type === "remarks") {
      setRemarksModalClass("none");
      setRemarksDisplay("");
    } else if (type === "dueAmount") {
      setDueAmountDisplay("none");
      setDueAmountModalClass("");
    } else if (type === "Payout") {
      setPayoutDisplay("none");
      setPayoutsModalClass("");
    } else if (type === "Comission") {
      setComissionDisplay("none");
      setComissionModalClass("");
    }

    if (document.body.style.overflow !== "scroll") {
      document.body.style.overflow = "scroll";
    } else {
      document.body.style.overflow = "hidden";
    }
    // onSearchSubmit();
    // dispatch(
    //   caseSearchAction({
    //     where,
    //     currentPage: 0,
    //     sortBy: "ts",
    //     sortOrder: -1,
    //     fullTextSearch: false,
    //     pageLength: 50,
    //   })
    // );
  };

  let data = [];
  // REDUX
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    search: { data: searchResults, count },
  } = useSelector((state) => state.CaseReducer, shallowEqual);
  const {
    search: { data: excelSearchResults, excelCount },
  } = useSelector((state) => state.ExcelReducer, shallowEqual);

  // const [counting, setCounting] = useState(0)
  // console.log("length",setCounting(counting+))
  const { userType, userId } = useSelector(
    (state) => state.AuthReducer,
    shallowEqual
  );
  const getPayout = (caseInfo, type) => {
    // PAYOUT
    let amount = 0;
    let ExistingAmount = 0;
    const duePercentage = caseInfo?.companyCommissionPercentage || 0;
    const PayoutPercentage = caseInfo?.agentCommissionPercentage || 0;
    // const increasedDuePercentage = Math.round((duePercentage + (duePercentage * 0.09)) * 100) / 100;
    const increasedDuePercentage = duePercentage + (duePercentage * 0.09);
    const payInPercentage = (caseInfo?.companyId?.companyName === 'HDFC BANK' && caseInfo?.companyId?.usedGSTCalc === "usedIsExclusiveHalf") ? increasedDuePercentage : duePercentage;
    const Percentage =
      type == "Payout"
        ? PayoutPercentage
        : payInPercentage;
    if (caseInfo.companyId.payOut === PAYOUT.LOANAMT)
      amount = Math.round(
        (caseInfo.meta.loanAmount -
          caseInfo.meta.EMIAmount *
          caseInfo.meta.EMIAdvance *
          Percentage) /
        100,
        2
      );
    else if (caseInfo.companyId.payOut === PAYOUT.LOANAMT_CROSSSALE)
      amount = Math.round(
        ((caseInfo.meta.loanAmount -
          caseInfo.meta.EMIAmount * caseInfo.meta.EMIAdvance +
          caseInfo.meta.crossSaleAmount) *
          Percentage) /
        100,
        2
      );
    else if (caseInfo.companyId.payOut === PAYOUT.LOANAMT_LESS_PF)
      amount = Math.round(
        ((caseInfo.meta.loanAmount -
          caseInfo.meta.EMIAmount * caseInfo.meta.EMIAdvance -
          caseInfo.meta.processingFees) *
          Percentage) /
        100,
        2
      );
    else
      amount = Math.round(
        ((caseInfo.meta.loanAmount -
          caseInfo.meta.EMIAmount * caseInfo.meta.EMIAdvance +
          caseInfo.meta.crossSaleAmount -
          caseInfo.meta.processingFees) *
          Percentage) /
        100,
        2
      );

    // const paymentDetails =
    //   type === "Payout" ? caseInfo.paymentDetails : caseInfo.recieptDetails;
    // ExtingAmount = paymentDetails?.reduce(
    //   (sum, payment) => sum + payment.amount,
    //   0
    // );

    const paymentDetails = type === "Payout" ? caseInfo.paymentDetails : caseInfo.recieptDetails;
    ExistingAmount = paymentDetails?.reduce((sum, payment) => {
      if (payment.deleted === true) {
        return sum; // Skip this payment object if deleted is true
      } else {
        return sum + payment.amount;
      }
    }, 0);

    amount -= ExistingAmount || 0;

    return isNaN(amount) ? 0 : amount;
  };

  const getCompletedDueAmount = (caseInfo) => {
    const { appliedCommissions, meta } = caseInfo;

    if (!appliedCommissions || appliedCommissions.length === 0) return 0;

    let totalAmount = 0;

    appliedCommissions.forEach((commission) => {
      const highestSlab = commission.slabs.reduce((highest, currentSlab) => {
        if (currentSlab.target > (highest?.target || 0) && currentSlab.completed) {
          return currentSlab;
        }
        return highest;
      }, null);

      if (!highestSlab) return;

      const grossLoanAmount = meta.grossLoanAmount
      highestSlab.amount = Math.round((grossLoanAmount * highestSlab.reward * 0.01));
      totalAmount += highestSlab.amount;
    });

    return totalAmount;
  };

  const getCompletedPayoutAmount = (caseInfo) => {
    const { appliedTargets, meta } = caseInfo;

    if (!appliedTargets || appliedTargets.length === 0) return 0;

    let totalAmount = 0;

    appliedTargets.forEach((target) => {
      const highestSlab = target.slabs.reduce((highest, currentSlab) => {
        if (currentSlab.target > (highest?.target || 0) && currentSlab.completed) {
          return currentSlab;
        }
        return highest;
      }, null);

      if (!highestSlab) return;

      const grossLoanAmount = meta.grossLoanAmount
      highestSlab.amount = Math.round((grossLoanAmount * highestSlab.reward * 0.01));
      totalAmount += highestSlab.amount;
    });

    return totalAmount;
  };

  const getGSTCalc = (DueAmt, ngstCalc, ugstCalc, loanCategory, companyName) => {
    // PAYOUT
    let amount = 0;
    if (loanCategory === "NEW") {
      if (ngstCalc === "newIsExclusive")
        // amount = Math.round(DueAmt + (DueAmt * 18) / 100);
        amount = Math.round((DueAmt * 18) / 100);
      else if (ngstCalc === "newIsInclusive")
        // amount = Math.round(DueAmt - ((DueAmt / 1.18) * 18) / 100);
        amount = Math.round(((DueAmt / 1.18) * 18) / 100);
      else if (ngstCalc === "newIsExclusiveHalf")
        // amount = Math.round(DueAmt + (DueAmt * 9) / 100);
        amount = Math.round((DueAmt * 9) / 100);
      //  (ngstCalc === "newIsExclusive18/118")
      // amount = Math.round(DueAmt + (DueAmt * 18) / 118);
      else amount = Math.round((DueAmt * 18) / 118);
    }
    if (loanCategory === "USED") {
      if (ugstCalc === "usedIsExclusive")
        // amount = Math.round(DueAmt + (DueAmt * 18) / 100);
        amount = Math.round((DueAmt * 18) / 100);
      else if (ugstCalc === "usedIsInclusive")
        // amount = Math.round(DueAmt - ((DueAmt / 1.18) * 18) / 100);
        amount = Math.round(((DueAmt / 1.18) * 18) / 100);
      else if (ugstCalc === "usedIsExclusiveHalf")
        if (companyName === 'HDFC BANK') {
          amount = Math.round((DueAmt * 18) / 118);
        }
        else {
          amount = Math.round((DueAmt * 9) / 100);
        }
      else amount = Math.round((DueAmt * 18) / 118);
    }
    return isNaN(amount) ? 0 : amount;
  };

  const totalDueGSTCalc = (DueAmt, ngstCalc, ugstCalc, loanCategory) => {
    // PAYOUT
    let amount = 0;
    if (loanCategory === "NEW") {
      if (ngstCalc === "newIsExclusive")
        amount = Math.round(DueAmt + (DueAmt * 18) / 100);
      // amount = Math.round((DueAmt * 18) / 100);
      else if (ngstCalc === "newIsInclusive")
        amount = Math.round(DueAmt - ((DueAmt / 1.18) * 18) / 100);
      // amount = Math.round(((DueAmt / 1.18) * 18) / 100);
      else if (ngstCalc === "newIsExclusiveHalf")
        amount = Math.round(DueAmt + (DueAmt * 9) / 100);
      // amount = Math.round((DueAmt * 9) / 100);
      //  (ngstCalc === "newIsExclusive18/118")
      // amount = Math.round(DueAmt + (DueAmt * 18) / 118);
      else amount = Math.round(DueAmt + (DueAmt * 18) / 118);
    }
    if (loanCategory === "USED") {
      if (ugstCalc === "usedIsExclusive")
        amount = Math.round(DueAmt + (DueAmt * 18) / 100);
      // amount = Math.round((DueAmt * 18) / 100);
      else if (ugstCalc === "usedIsInclusive")
        amount = Math.round(DueAmt - ((DueAmt / 1.18) * 18) / 100);
      // amount = Math.round(((DueAmt / 1.18) * 18) / 100);
      else if (ugstCalc === "usedIsExclusiveHalf")
        amount = Math.round(DueAmt + (DueAmt * 9) / 100);
      // amount = Math.round((DueAmt * 9) / 100);
      // else amount = Math.round(DueAmt + (DueAmt * 18) / 118);
      else amount = Math.round(DueAmt + (DueAmt * 18) / 118);
    }
    return isNaN(amount) ? 0 : amount;
  };

  const getTotalAmount = (Object) => {
    let totalAmt = 0;
    Object.map((obj) => {
      if (!obj?.deleted) {
        totalAmt += obj.amount || 0;
      }
    });
    return isNaN(totalAmt) ? 0 : totalAmt;
  };
  const getCommissionDetails = () => {
    try {
      if (!Array.isArray(commissionMaster.slab)) {
        throw new Error("Commission slab is not an array");
      }

      const commissionDetails = commissionMaster.slab.map((slab) => {
        const status = (total?.totalGrossAmt || 0) >= slab.target ? "Completed" : "Short";
        const amount = parseInt(((total?.totalGrossAmt || 0) * slab.reward) / 100);
        // const amount = (slab.target * slab.reward) / 100;
        const short = status === "Short" ? slab.target - (total?.totalGrossAmt || 0) : 0;

        return {
          commissionTarget: slab.target,
          tillNow: (total?.totalGrossAmt || 0),
          reward: slab.reward,
          amount,
          status,
          short,
          isRewardPercentage: slab.isRewardPercentage,
        };
      });

      return commissionDetails;
    } catch (error) {
      console.error("Error in getCommissionDetails:", error.message);
    }
  };

  // function mergeAgentLoansAndCalculateTargets(agentLoanSums) {
  //   // Step 1: Merge agent loan sums
  //   const mergedSums = {};
  //   for (const item of agentLoanSums) {
  //     if (mergedSums[item.agentId]) {
  //       mergedSums[item.agentId].sum += item.sum;
  //     } else {
  //       mergedSums[item.agentId] = { ...item };
  //     }
  //   }
  // 
  //   // Step 2: Calculate target details for each agent
  //   const agentTargetDetails = {};
  
  //   for (const [agentId, agentData] of Object.entries(mergedSums)) {
  //     if (!Array.isArray(targetMaster.slab)) {
  //       console.error("Target slab is not an array");
  //       continue;
  //     }
  
  //     const agentSum = agentData.sum;
  //     const targetDetails = targetMaster.slab.map((slab) => {
  //       console.log('slab', slab)
  //       const status = agentSum >= slab.target ? "Completed" : "Short";
  //       const amount = parseInt((agentSum * slab.reward) / 100);
  //       const short = status === "Short" ? slab.target - agentSum : 0;
  
  //       return {
  //         targetGoal: slab.target,
  //         tillNow: agentSum,
  //         reward: slab.reward,
  //         amount,
  //         status,
  //         short,
  //         isRewardPercentage: slab.isRewardPercentage,
  //       };
  //     });
  
  //     agentTargetDetails[agentId] = {
  //       ...agentData,
  //       targetDetails,
  //     };
  //   }
  //   return agentTargetDetails;
  // }
  function mergeAgentLoanSums(agentLoanSums) {
    if (!agentLoanSums || agentLoanSums.length === 0) {
      return;
  }
    const mergedSums = [];
  
    for (const item of agentLoanSums) {
      const existingAgent = mergedSums.find(agent => agent.agentId === item.agentId);
      
      if (existingAgent) {
        existingAgent.sum += item.sum;
      } else {
        mergedSums.push({ agentId: item.agentId, sum: item.sum });
      }
    }
    setAgentLoanSumList(mergedSums);
  }
  const getTargetDetails = () => {
    try {
      if (!Array.isArray(targetMaster.slab)) {
        throw new Error("Target slab is not an array");
      }

      const targetDetails = targetMaster.slab.map((slab) => {
        const status = (total?.totalGrossAmt || 0) >= slab.target ? "Completed" : "Short";
        const amount = parseInt(((total?.totalGrossAmt || 0) * slab.reward) / 100);
        // const amount = (slab.target * slab.reward) / 100;
        const short = status === "Short" ? slab.target - (total?.totalGrossAmt || 0) : 0;

        return {
          targetGoal: slab.target,
          tillNow: (total?.totalGrossAmt || 0),
          reward: slab.reward,
          amount,
          status,
          short,
          isRewardPercentage: slab.isRewardPercentage,
        };
      });

      return targetDetails;
    } catch (error) {
      console.error("Error in getTargetDetails:", error.message);
    }
  }; 
  
  const getAgentWiseTargetDetails = () => {
    try {
      if (!Array.isArray(targetMaster.slab)) {
        throw new Error("Target slab is not an array");
      }
      const agentTargetDetails = [];

      for (const agentData of agentLoanSumList) {
        const agentId = agentData.agentId;
        const agentSum = agentData.sum;
        
        const agentDetails = targetMaster.slab.map((slab) => {
          const status = agentSum >= slab.target ? "Completed" : "Short";
          const amount = parseInt((agentSum * slab.reward) / 100);
          const short = status === "Short" ? slab.target - agentSum : 0;
          const agent = targetMaster.agentIds.find(agent => agent._id === agentId);
          const name = agent ? `${agent.personalInfo.firstName} ${agent.personalInfo.lastName} ${agent.personalInfo.phone}` : '';
      
          return {
            name,
            targetGoal: slab.target,
            tillNow: agentSum,
            reward: slab.reward,
            amount,
            status,
            short,
            isRewardPercentage: slab.isRewardPercentage,
          };
        });
        
        agentTargetDetails.push(...agentDetails);
      }
      return agentTargetDetails;
    } catch (error) {
      console.error("Error in getAgentWiseTargetDetails:", error.message);
      return [];
    }
  };
  //Set Comission Names if the comission target is achieved

  // const setComissionName=useCallback(
  //   () => {
  //     console.log("inside comission name",commissionMaster.commissionName)
  //     searchResults.map((case)=>{})
  //   },
  //   [searchResults],
  // )

  const activitiesFromSearch = useMemo(() => {
    if (!searchResults) {
      return [];
    }
    const PrepairData = [];
    let totalGrossAmt = 0;
    let totalNetAmt = 0;
    let totalPayoutAmount = 0;
    let totalDueAmount = 0;
    let totalPaymentAmount = 0;
    let totalReceiptAmount = 0;
    searchResults.forEach((caseInfo) => {
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const ngstCalc = caseInfo.companyId.newGSTCalc;
      const ugstCalc = caseInfo.companyId.usedGSTCalc;
      const loanCategory = caseInfo.meta.loanType;
      const defaultDueAmount = getPayout(caseInfo, "Due");
      const completedCommissionsDueAmount = getCompletedDueAmount(caseInfo);
      const DueAmount = defaultDueAmount + completedCommissionsDueAmount;
      if (!isNaN(DueAmount)) {
        totalDueAmount += DueAmount;
        setTotalDueAmount(totalDueAmount);
        // console.log("dp", totalDueAmount)
      }
      const defaultPayoutAmount = getPayout(caseInfo, "Payout");
      const completedTargetsPayoutAmount = getCompletedPayoutAmount(caseInfo);
      const payoutAmount = defaultPayoutAmount + completedTargetsPayoutAmount;
      if (!isNaN(payoutAmount)) {
        totalPayoutAmount += payoutAmount;
        setTotalPayout(totalPayoutAmount);
      }
      const GSTEncExc = getGSTCalc(DueAmount, ngstCalc, ugstCalc, loanCategory);
      const totalDuewithGST = totalDueGSTCalc(DueAmount, ngstCalc, ugstCalc, loanCategory);
      const agentName =
        caseInfo.agentId.personalInfo.firstName +
        " " +
        caseInfo.agentId.personalInfo.lastName +
        "-" +
        caseInfo.agentId.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      if (!isNaN(paymentAmount)) {
        totalPaymentAmount += paymentAmount;
        setNetPaid(totalPaymentAmount);
      }
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      if (!isNaN(receiptAmount)) {
        totalReceiptAmount += receiptAmount;
        setTotalReceived(totalReceiptAmount);
      }
      const difference = receiptAmount - paymentAmount;
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      setGrossLoan(totalGrossAmt);
      totalNetAmt +=
        caseInfo.meta.loanAmount -
        caseInfo.meta.crossSaleAmount -
        caseInfo.meta.processingFees;
      if (!isNaN(totalNetAmt)) {
        setNetLoan(totalNetAmt);
      }
      const loanType =
        caseInfo.meta.loanType + " " + (caseInfo.meta?.usedCarType || "");
      // const businessIRR = caseInfo.meta.businessIRR.toFixed(2);
      const currentDate = new Date();
      const otherDate = new Date(caseInfo.meta.loanDate);
      const timeDifference = Math.abs(
        currentDate.getTime() - otherDate.getTime()
      );
      const dayCount = Math.ceil(timeDifference / (1000 * 3600 * 24));
      const isPending =
        (!caseInfo.meta.RCRecv ||
          !caseInfo.meta.insuranceRec ||
          !caseInfo.meta.invoiceRecv ||
          !caseInfo.meta.parivahanStatus ||
          !caseInfo.meta.rtoSlip) &&
        new Date() - new Date(caseInfo.meta.loanDate) >=
        30 * 24 * 60 * 60 * 1000 &&
        new Date() - new Date(caseInfo.meta.loanDate) <=
        60 * 24 * 60 * 60 * 1000;
      const isCritical =
        (!caseInfo.meta.RCRecv ||
          !caseInfo.meta.insuranceRec ||
          !caseInfo.meta.invoiceRecv ||
          !caseInfo.meta.parivahanStatus ||
          !caseInfo.meta.rtoSlip) &&
        new Date() - new Date(caseInfo.meta.loanDate) >=
        61 * 24 * 60 * 60 * 1000;

      PrepairData.push({
        ...caseInfo,
        payoutAmount,
        DueAmount,
        CrossSellAmount,
        GSTEncExc,
        totalDuewithGST,
        agentName,
        amount,
        loanType,
        customerName,
        isPending,
        isCritical,
        dayCount,
        paymentAmount,
        receiptAmount,
        difference,
      });
    });
    const commissionDetails = getCommissionDetails();
    const targetDetails = getTargetDetails();
    const agentWiseTargetDetails=getAgentWiseTargetDetails();

    const results = {
      data: PrepairData,
      count,
      currentPageIndex,
      commissionDetails,
      targetDetails,
      agentWiseTargetDetails
    };

    return results;
  }, [
    searchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
    currentPageIndex,
    totalDueAmount,
    totalPayout,
  ]);




  // PAGE CHANGE
  const onPageChange = useCallback(
    (currentPage) => {
      setCurrentPageIndex(currentPage);
      dispatch(
        caseSearchAction({
          where,
          currentPage,
          fullTextSearch: true,
        })
      );
    },
    [
      dispatch,
      caseSearchAction,
      where,
      currentPageIndex,
      // currentPage,
      // where,
      // fullTextSearch,
    ]
  );

  const onSearchSubmit = useCallback(
    async (values, formikUtils) => {
      formikUtils.setSubmitting(false);
      const {
        productCategory,
        loanType,
        usedCarLoanType,
        CaseFromDate,
        CaseToDate,
        companyId,
        customerId,
        agentId,
        reportingManagerId,
        FilterCommissionId,
        FilterTargetId,
        employmentType,
        LoanPolicyNumber,
      } = values;


      // Check if CaseFromDate and CaseToDate are present only if FilterCommissionId is not present
      if ((!FilterCommissionId && !FilterTargetId) && (!CaseFromDate || !CaseToDate)) {
        dispatch(
          headerShowAction({
            data: "CaseFromDate and CaseToDate are required filters.",
          })
        );
        return;
      }

      // if (
      //   // THERE MUST BE AT LEAST ONE FILTER
      //   [
      //     productCategory,
      //     loanType,
      //     usedCarLoanType,
      //     CaseFromDate,
      //     CaseToDate,
      //     companyId,
      //     FilterCommissionId,
      //     agentId,
      //     reportingManagerId,
      //     employmentType,
      //     LoanPolicyNumber,
      //   ].filter((item) => !!item).length < 1
      // ) {
      //   dispatch(
      //     headerShowAction({
      //       data: "There must at least one filter to be added.",
      //     })
      //   );
      //   return;
      // }

      let where = {};

      // product Category
      if (productCategory) {
        set(where, "productCategory", productCategory);
        setProductCategory(productCategory);
      } else {
        setProductCategory(null);
      }

      if (loanType) {
        set(where, "meta.loanType", loanType);
      }
      if (usedCarLoanType) set(where, "meta.usedCarType", usedCarLoanType);

      // company
      if (companyId) {
        set(where, "companyId", companyId);
        setCurrentCompany(companyId);
      } else {
        setCurrentCompany(null);
      }

      // FROM
      if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
        const fromDate = getStartOfDay(CaseFromDate);
        setCurrentActivityAssignedDateFrom(CaseFromDate);
        set(where, "meta.loanDate", { $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateFrom(null);
      }

      // TILL
      if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
        const tillDate = getEndOfDay(CaseToDate);
        const fromDate = getStartOfDay(CaseFromDate);
        setCurrentActivityAssignedDateTill(CaseToDate);

        set(where, "meta.loanDate", { $lte: tillDate });
        if (fromDate)
          set(where, "meta.loanDate", { $lte: tillDate, $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateTill(null);
      }

      // CLIENT
      if (agentId) {
        where.agentId = agentId;
      }

      if (reportingManagerId) {
        where.reportingManagerId = reportingManagerId;
      }
      //CUSTOMER
      if (customerId) {
        where.customerId = customerId;
      }
      // CommissionId
      if (FilterCommissionId) {
        where = {};

        // Set up commissionId filter
        const commissionId = { _id: FilterCommissionId };
        const localWhere = { ...commissionId }; // Create a local 'where' for commission search
        // Fetch commission details
        let {
          data: {
            data: { data: commissionMasterDT },
          },
        } = await commissionSearchAPI({
          where: { ...localWhere },
          autopopulate: false,
        });
        commissionMasterDT = commissionMasterDT[0];

        // Set commission master details
        setCommissionMaster(commissionMasterDT);

        // Calculate date range
        const fromDate = getStartOfDay(commissionMasterDT.FromDate);
        const tillDate = getEndOfDay(commissionMasterDT.ToDate);
        const loanType = commissionMasterDT.loanType;
        // Fetch company details
        let {
          data: {
            data: { data: company },
          },
        } = await companySearchAPI({
          where: { _id: commissionMasterDT.companyId },
          autopopulate: false,
        });
        company = company[0];
        // Set date range for current activity
        setCurrentActivityAssignedDateFrom(fromDate);
        setCurrentActivityAssignedDateTill(tillDate);


        // Update form values
        values.CaseFromDate = fromDate;
        values.CaseToDate = tillDate;
        values.companyId = company._id;
        values.loanType = loanType;
        // Set meta filter for loan date
        set(where, "meta.loanDate", { $gte: fromDate, $lte: tillDate });
        set(where, "companyId", company._id);
        set(where, "meta.loanType", loanType);


        // Set additional filters if applicable
        // if (commissionMasterDT.loanType)
        //     set(where, 'loanType', commissionMasterDT.loanType);
        // if (commissionMasterDT.loanType == "USED" && commissionMasterDT.usedCarType)
        //     set(where, 'usedCarType', commissionMasterDT.usedCarType);
      } else {
        // Handle case where FilterCommissionId is not present
        // setCurrentCompany(null);
      }

      // TargetId
      if (FilterTargetId) {
        let dupWhere = where;
        // Set up TargetId filter
        const targetId = { _id: FilterTargetId };
        const localWhere = { ...targetId }; // Create a local 'where' for target search
        // Fetch target details
        let {
          data: {
            data: { data: targetMasterData },
          },
        } = await targetSearchAPI({
          where: { ...localWhere },
          autopopulate: true,
        });
        targetMasterData = targetMasterData[0];
        // Set target master details
        setTargetMaster(targetMasterData);

        // Calculate date range
        const fromDate = getStartOfDay(targetMasterData.FromDate);
        const tillDate = getEndOfDay(targetMasterData.ToDate);
        const loanType = targetMasterData.loanType;
        // Fetch company details
        let {
          data: {
            data: { data: company },
          },
        } = await companySearchAPI({
          where: { _id: targetMasterData.companyId },
          autopopulate: false,
        });
        company = company[0];
        // Set date range for current activity
        setCurrentActivityAssignedDateFrom(fromDate);
        setCurrentActivityAssignedDateTill(tillDate);


        // Update form values
        values.CaseFromDate = fromDate;
        values.CaseToDate = tillDate;
        values.companyId = company._id;
        values.loanType = loanType;
        // Set meta filter for loan date
        where = dupWhere
        set(where, "meta.loanDate", { $gte: fromDate, $lte: tillDate });
        set(where, "companyId", company._id);
        set(where, "meta.loanType", loanType);
        // Handle agentIds
        const agentIds = targetMasterData.agentIds.map(agent => agent._id);

        if (!dupWhere.agentId) {
          values.agentId = agentIds;
          set(where, "agentId", { $in: agentIds });
        } else {
          set(where, "agentId", { $in: dupWhere.agentId });
        }
      }
      if (employmentType) {
        const fetchUserIds = async (type, currentPage = 0) => {
          let allUserIds = [];
          let { data: { data: { data: userIdsChunk, pages } } } = await userSearchAPI({
            where: { employmentType: type },
            currentPage,
          });

          allUserIds = [...allUserIds, ...userIdsChunk.map(user => user._id)];
          const totalPages = pages;
          if (currentPage < totalPages) {
            const remainingUserIds = await fetchUserIds(type, currentPage + 1);
            allUserIds = [...allUserIds, ...remainingUserIds];
          }

          return allUserIds;
        };
        const getUserIds = async (employmentType) => {
          if (employmentType === "onroll&dsa") {
            const onRollUserIds = await fetchUserIds("ON_ROLL");
            const dsaUserIds = await fetchUserIds("DSA");
            return [...onRollUserIds, ...dsaUserIds];
          }
          return await fetchUserIds(employmentType);
        };

        const userIds = await getUserIds(employmentType);

        set(where, "agentId", { $in: userIds });
      }
      //LoanPolicyNumber
      if (LoanPolicyNumber) {
        if (productCategory === "VEHICLE_INSURANCE")
          set(where, "coverNotes.cn_number", LoanPolicyNumber);
        else set(where, "meta.LoanAccountNo", LoanPolicyNumber);
      }

      setWhere(where);

      pipeline(where);

      dispatch(
        excelCaseSearchAction({
          where,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
        })
      );

      dispatch(
        caseSearchAction({
          where,
          currentPage: 0,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
          pageLength: 50,
        })
      );
    },
    [dispatch]
  );


  const pipeline = async (where) => {

    // Stage 2: Calculate payoutAmount
    const calculatePayoutStage = {
      $addFields: {
        payoutAmount: {
          $switch: {
            branches: [
              {
                case: {
                  $eq: ["$companyDoc.payOut", "LoanAmtCrossSale"]
                },
                then: {
                  $round: {
                    $multiply: [
                      {
                        $sum: [
                          "$meta.loanAmount",
                          {
                            $multiply: [
                              -1,
                              {
                                $multiply: [
                                  "$meta.EMIAmount",
                                  "$meta.EMIAdvance"
                                ]
                              }
                            ]
                          },
                          "$meta.crossSaleAmount"
                        ]
                      },
                      {
                        $divide: [
                          "$agentCommissionPercentage",
                          100
                        ]
                      }
                    ]
                  }
                }
              },
              {
                case: {
                  $eq: ["$companyDoc.payOut", "LoanAmtLessPF"]
                },
                then: {
                  $round: {

                    $multiply: [
                      {
                        $sum: [
                          "$meta.loanAmount",
                          {
                            $multiply: [
                              -1,
                              {
                                $sum: [
                                  {
                                    $multiply: [
                                      "$meta.EMIAmount",
                                      "$meta.EMIAdvance"
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            $multiply: [
                              -1,
                              "$meta.processingFees"
                            ]
                          }
                        ]
                      },
                      {
                        $divide: [
                          "$agentCommissionPercentage",
                          100
                        ]
                      }
                    ]
                  }

                }
              },
              {
                case: {
                  $eq: ["$companyDoc.payOut", "LoanAmt"]
                },
                then: {
                  $round: {

                    $multiply: [
                      {
                        $sum: [
                          "$meta.loanAmount",
                          {
                            $multiply: [
                              -1,
                              {
                                $multiply: [
                                  "$meta.EMIAmount",
                                  "$meta.EMIAdvance"
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        $divide: [
                          "$agentCommissionPercentage",
                          100
                        ]
                      }
                    ]
                  }

                }
              },
              {
                case: {},
                then: {
                  $round: {
                    $multiply: [
                      {
                        $subtract: [
                          {
                            $sum: [
                              "$meta.loanAmount",
                              "$meta.crossSaleAmount"
                            ]
                          },
                          {
                            $sum: [
                              {
                                $multiply: [
                                  "$meta.EMIAmount",
                                  "$meta.EMIAdvance"
                                ]
                              },
                              "$meta.processingFees"
                            ]
                          }
                        ]
                      },
                      {
                        $divide: [
                          "$agentCommissionPercentage",
                          100
                        ]
                      }
                    ]
                  }
                }
              }
            ],
            default: 0
          }
        }
      }
    };
    // Stage 3: Calculate existing amount for payoutAmount
    const calculateExistingAmountForPayout = {
      $addFields: {
        existingAmountForPayout: {
          $cond: [
            { $eq: [{ $size: { $ifNull: ["$paymentDetails", []] } }, 0] },
            0,
            {
              $reduce: {
                input: {
                  $filter: {
                    input: "$paymentDetails",
                    cond: { $not: "$$this.deleted" } // Filter out payments where deleted is true
                  }
                },
                initialValue: 0,
                in: { $sum: ["$$value", "$$this.amount"] }
              }
            }
          ]
        }
      }
    }

    // Stage 4: Calculate grand total payoutAmount
    const calculatePayoutAmountStage = {
      $addFields: {
        finalPayoutAmount: { $subtract: ["$payoutAmount", "$existingAmountForPayout"] }
      }
    };

    // Stage 5: Select percentage based on company
    const calculatePercentage = {
      $addFields: {
        payInPercentage: {
          $cond: {
            if: {
              $and: [
                { $eq: ["$companyDoc.companyName", "HDFC BANK"] },
                { $eq: ["$companyDoc.usedGSTCalc", "usedIsExclusiveHalf"] }
              ]
            },
            then: {
              $add: [
                "$companyCommissionPercentage",
                {
                  $multiply: [
                    "$companyCommissionPercentage",
                    0.09
                  ]
                }
              ]
            },
            else: "$companyCommissionPercentage"
          }
        }
      }
    }

    // Stage 6: Calculate default/Monthly dueAmount
    const calculateDefaultDueAmount = {
      $addFields: {
        defaultDueAmount: {
          $switch: {
            branches: [
              {
                case: {
                  $eq: ["$companyDoc.payOut", "LoanAmtCrossSale"]
                },
                then: {
                  $round: {
                    $multiply: [
                      {
                        $sum: [
                          "$meta.loanAmount",
                          {
                            $multiply: [
                              -1,
                              {
                                $multiply: [
                                  "$meta.EMIAmount",
                                  "$meta.EMIAdvance"
                                ]
                              }
                            ]
                          },
                          "$meta.crossSaleAmount"
                        ]
                      },
                      {
                        $divide: ["$payInPercentage", 100]
                      }
                    ]
                  }
                }
              },
              {
                case: {
                  $eq: ["$companyDoc.payOut", "LoanAmtLessPF"]
                },
                then: {
                  $round: {

                    $multiply: [
                      {
                        $sum: [
                          "$meta.loanAmount",
                          {
                            $multiply: [
                              -1,
                              {
                                $sum: [
                                  {
                                    $multiply: [
                                      "$meta.EMIAmount",
                                      "$meta.EMIAdvance"
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            $multiply: [
                              -1,
                              "$meta.processingFees"
                            ]
                          }
                        ]
                      },
                      {
                        $divide: ["$payInPercentage", 100]
                      }
                    ]
                  }

                }
              },
              {
                case: {
                  $eq: ["$companyDoc.payOut", "LoanAmt"]
                },
                then: {
                  $round: {
                    $multiply: [
                      {
                        $sum: [
                          "$meta.loanAmount",
                          {
                            $multiply: [
                              -1,
                              {
                                $multiply: [
                                  "$meta.EMIAmount",
                                  "$meta.EMIAdvance"
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        $divide: ["$payInPercentage", 100]
                      }
                    ]
                  }

                }
              },
              {
                case: {},
                then: {
                  $round: {
                    $multiply: [
                      {
                        $subtract: [
                          {
                            $sum: [
                              "$meta.loanAmount",
                              "$meta.crossSaleAmount"
                            ]
                          },
                          {
                            $sum: [
                              {
                                $multiply: [
                                  "$meta.EMIAmount",
                                  "$meta.EMIAdvance"
                                ]
                              },
                              "$meta.processingFees"
                            ]
                          }
                        ]
                      },
                      {
                        $divide: ["$payInPercentage", 100]
                      }
                    ]
                  }
                }
              }
            ],
            default: 0
          }
        }
      }
    };

    // Stage 7: Calculate and sum all the special commissions due amount
    const calculateSpecialCommissionsDueAmount = {
      $addFields: {
        totalSpecialCommissionDueAmount: {
          $cond: {
            if: {
              $and: [
                { $isArray: "$appliedCommissions" },
                { $gt: [{ $size: { $ifNull: ["$appliedCommissions", []] } }, 0] }
              ]
            },
            then: {
              $sum: {
                $map: {
                  input: "$appliedCommissions",
                  as: "commission",
                  in: {
                    $let: {
                      vars: {
                        highestSlab: {
                          $arrayElemAt: [
                            {
                              $filter: {
                                input: "$$commission.slabs",
                                cond: {
                                  $and: [
                                    { $eq: ["$$this.completed", true] },
                                    { $ne: ["$$this.target", null] }
                                  ]
                                }
                              }
                            },
                            -1
                          ]
                        }
                      },
                      in: {
                        $cond: {
                          if: { $gt: ["$$highestSlab.target", 0] },
                          then: {
                            $round:
                            {
                              $multiply: [
                                "$meta.grossLoanAmount",
                                "$$highestSlab.reward",
                                0.01
                              ]
                            },

                          },
                          else: 0
                        }
                      }
                    }
                  }
                }
              }
            },
            else: 0
          }
        }
      }
    };

    // Stage 8: Calculate existing/paid amount for due
    const calculateExistingAmountForDue = {
      $addFields: {
        existingAmountForDue: {
          $cond: [
            { $eq: [{ $size: { $ifNull: ["$recieptDetails", []] } }, 0] },
            0,
            {
              $reduce: {
                input: {
                  $filter: {
                    input: "$recieptDetails",
                    cond: { $not: "$$this.deleted" } // Filter out payments where deleted is true
                  }
                },
                initialValue: 0,
                in: { $sum: ["$$value", "$$this.amount"] }
              }
            }
          ]
        }
      }
    };

    // Stage 9: Calculate grand total dueAmount((specialCommission + defaultCommission)-existingAmount)
    const calculateDueAmountStage = {
      $addFields: {
        finalDueAmount: {
          $subtract: [
            {
              $add: ['$totalSpecialCommissionDueAmount', '$defaultDueAmount']
            },
            "$existingAmountForDue"
          ]
        }
      }
    };

    const groupStage = {
      $group: {
        _id: null,
        totalGrossAmt: {
          $sum: {
            $ifNull: ['$meta.grossLoanAmount', 0]
          }
        },
        totalNetAmt: {
          $sum: {
            $subtract: [
              '$meta.loanAmount',
              {
                $add: ['$meta.crossSaleAmount', '$meta.processingFees']
              }
            ]
          }
        },
        totalPayoutAmount: {
          $sum: "$finalPayoutAmount"
        },
        totalExistingAmountForPayout: {
          $sum: '$existingAmountForPayout'
        },
        defaultDueAmount: {
          $sum: "$defaultDueAmount"
        },
        totalDueAmount: {
          $sum: "$finalDueAmount"
        },
        totalSpecialCommissionDueAmount: {
          $sum: '$totalSpecialCommissionDueAmount'
        },
        totalExistingAmountForDue: {
          $sum: '$existingAmountForDue'
        },
        agentLoanSums: {
          $push: {
            $cond: {
              if: { $gt: ["$agentLoanSum", 0] },
              then: {
                agentId: "$agentId",
                sum: "$agentLoanSum",
                // debug_match: "$debug_agentIdMatch",
                // debug_grossLoanAmount: "$debug_grossLoanAmount"
              },
              else: "$$REMOVE"
            }
          }
        },
        // debug_agentIdMatch: { $first: "$debug_agentIdMatch" },
        // debug_grossLoanAmount: { $first: "$debug_grossLoanAmount" },
        // debug_agentIds: { $first: "$debug_agentIds" },
        // totalLoanSum: { $sum: "$agentLoanSum" },
        count: { $sum: 1 },
      }
    };

    const projectStage = {
      $project: {
        _id: 0,
        totalGrossAmt: 1,
        totalNetAmt: 1,
        totalPayoutAmount: 1,
        totalExistingAmountForPayout: 1,
        defaultDueAmount: 1,
        totalDueAmount: 1,
        totalSpecialCommissionDueAmount: 1,
        totalExistingAmountForDue: 1,
        companyDoc: 1,
        count: 1,
        agentLoanSums: 1,
        // debug_agentIdMatch: 1,
        // debug_grossLoanAmount: 1,
        // debug_agentIds: 1,
        // totalLoanSum: 1
      }
    };

    const pipelineStages = [
      // ... your existing stages ...
      calculatePayoutStage,
      calculateExistingAmountForPayout,
      calculatePayoutAmountStage,
      calculatePercentage,
      calculateDefaultDueAmount,
      calculateSpecialCommissionsDueAmount,
      calculateExistingAmountForDue,
      calculateDueAmountStage,
      groupStage,
      projectStage
    ];
    
    const pipelineHelper = {
      where,
      pipelineStages
    }
    let {
      data: {
        data: [totalPipe]
      }
    } = await pipelineApi(pipelineHelper);
    setTotal(totalPipe)
    mergeAgentLoanSums(totalPipe?.agentLoanSums)
  }

  // const onCommissionSubmit = useCallback(async (
  //     values,
  //     formikUtils,
  // ) => {
  //     formikUtils.setSubmitting(false);
  //     const {
  //         FilterCommissionId,
  //     } = values;

  //     let where = {
  //     };

  //     // FROM
  //     if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
  //         const fromDate = getStartOfDay(CaseFromDate);
  //         setCurrentActivityAssignedDateFrom(CaseFromDate);
  //         set(where, 'ts', { $gte: fromDate });
  //     }
  //     else {
  //         setCurrentActivityAssignedDateFrom(null);
  //     }

  //     // TILL
  //     if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
  //         const tillDate = getEndOfDay(CaseToDate);
  //         setCurrentActivityAssignedDateTill(CaseToDate);
  //         set(where, 'ts', { $lte: tillDate });
  //     }
  //     else {
  //         setCurrentActivityAssignedDateTill(null);
  //     }
  //     //FilterCommissionId
  //     if(FilterCommissionId)
  //     {
  //         set(where, 'ts', { $lte: tillDate });
  //     }
  //     setWhere(where);
  //     dispatch(caseSearchAction({
  //         where,
  //         currentPage: 0,
  //         sortBy: 'ts',
  //         sortOrder: -1,
  //         fullTextSearch: false,
  //         pageLength: 10,
  //     }));
  // }, [
  //     dispatch,
  // ]);

  const onClear = useCallback(() => {
    dispatch(caseResetAction());
    setFilterInitialValues({
      ...filterDefaultValues,
    });
  }, [dispatch]);

  const generateInvoice = useCallback(
    async (commissionId) => {
      const payload = {
        commissionId: commissionId,
        data: invoiceInitialValues,
      };
      const invoice = await caseInvoiceCreateAPI(payload);
      closeAlertDialog("invoice");
      dispatch(
        headerShowAction({
          data: "Invoice has been created successfully.",
        })
      );
    },
    [invoiceInitialValues]
  );

  const handleReceipt = useCallback();
  //   async (_id) => {
  //     const payload = {
  //       caseId:_id,
  //       value:[{
  //         mode:mode,
  //         date:date,
  //         amount:AmountToReceive,
  //         instrument_number:'',
  //         remarks:''
  //       }]

  //     };
  //     const receipt = await caseReceiptCreateAPI(payload);
  //     closeAlertDialog("dueAmount");
  //     dispatch(
  //       headerShowAction({
  //         data: "Receipt updated successfully.",
  //       })
  //     );
  //   },
  //   []
  const handlePayment = useCallback();
  //   async (_id) => {
  //     const payload = {
  //       commissionId: commissionId,
  //       data: invoiceInitialValues,
  //     };
  //     const invoice = await casePaymentCreateAPI(payload);
  //     closeAlertDialog("Payout");
  //     dispatch(
  //       headerShowAction({
  //         data: " Payment updated successfully.",
  //       })
  //     );
  //   },
  //   [invoiceInitialValues]
  const handleChange = useCallback(
    async (e) => {
      const id = e.target.name;
      const checked = e.target.value;
      const payOut = parseInt(e.target.getAttribute("data-payout"));
      const due = parseInt(e.target.getAttribute("data-due"));
      const paid = parseInt(e.target.getAttribute("data-paid"));
      const received = parseInt(e.target.getAttribute("data-received"));
      const agentId = e.target.getAttribute("data-agentid");
      const casecode = e.target.getAttribute("data-casecode");
  
      // Fetch total debit and credit amounts and calculate the advance balance
      const totalDebit = await fetchTotalDebitForAgent(agentId);
      const totalCredit = await fetchTotalCreditForAgent(agentId);
      const totalAdvanceBalance = Math.max(totalDebit - totalCredit,0);
      
      // Calculate the adjusted payout after subtracting the advance balance
      const adjustedPayOut = Math.max(payOut - totalAdvanceBalance, 0);
      
      setAgentIdForAdvance(agentId);
      setCaseCodeForAdvance(casecode);
      
      if (checked === "false") {
        setTotalAdvanceAmount((prev)=> prev + totalAdvanceBalance);
        setRemainingPayOut((prev)=> prev + adjustedPayOut);
        setInvoiceInitialValues([...invoiceInitialValues, id]);
        setPendingPayOutList([...pendingPayOutList, { id, amount: payOut }]);
        setPendingDueList([...pendingDueList, { id, amount: due }]);
        setReceived((prevTotal) => prevTotal + received);
        setPaid((prevTotal) => prevTotal + paid);
        setTotalCheckedPayOut((prevTotal) => prevTotal + payOut);
        setTotalCheckedDue((prevTotal) => prevTotal + due);
      } else {
        setTotalAdvanceAmount((prev)=> Math.max(prev - totalAdvanceBalance,0));
        setRemainingPayOut((prev)=> Math.max(prev - adjustedPayOut,0));
        setInvoiceInitialValues(invoiceInitialValues.filter((item) => item !== id));
        setPendingPayOutList(pendingPayOutList.filter((item) => item.id !== id));
        setPendingDueList(pendingDueList.filter((item) => item.id !== id));
        setReceived((prevTotal) => prevTotal - received);
        setPaid((prevTotal) => prevTotal - paid);
        setTotalCheckedPayOut((prevTotal) => prevTotal - payOut);
        setTotalCheckedDue((prevTotal) => prevTotal - due);
      }
    },
    [invoiceInitialValues, pendingPayOutList, pendingDueList]
  );
  
  // Fetch total debit amount for the agent
  const fetchTotalDebitForAgent = async (agentId) => {
    try {
      let response = await walletPaymentSearchAPI({
        where: { agentId, category: 'debit' },
      });
      let walletData = response?.data?.data?.data ?? [];
      const totalDebit = walletData.reduce((total, record) => total + (record?.amount || 0), 0);
      return totalDebit;
    } catch (error) {
      console.error('Error fetching debit amount for agent:', error);
      return 0; // Return 0 if an error occurs or no data is found
    }
  };
  
  // Fetch total credit amount for the agent
  const fetchTotalCreditForAgent = async (agentId) => {
    try {
      let response = await walletPaymentSearchAPI({
        where: { agentId, category: 'credit' },
      });
      let walletData = response?.data?.data?.data ?? [];
      const totalCredit = walletData.reduce((total, record) => total + (record?.amount || 0), 0);
      return totalCredit;
    } catch (error) {
      console.error('Error fetching credit amount for agent:', error);
      return 0; // Return 0 if an error occurs or no data is found
    }
  };
  

  // The separate function to perform updates upon submission
  const handleSubmitUpdates = async (values) => {
    try {
        const {ReceiptDue,advanceBalance,remaningAmount, mode, instrument_number, date } = values;
  
        if (remaningAmount > 0) {
            // 1. Create a wallet payment for the live payment (remaining amount)
            await walletPaymentCreateAPI({
                data: {
                    agentId: agentIdForAdvance,
                    amount: remaningAmount,
                    mode,
                    category: 'credit',
                    caseCode: caseCodeForAdvance,
                    payment_type: 'live_payment',
                    instrument_number,
                    payment_date: date,
                    remarks: 'Remaining payout after advance adjustment',
                },
            });

            // 2. Create a wallet payment for the amount covered by advance (advance adjustment)
            await walletPaymentCreateAPI({
                data: {
                    agentId: agentIdForAdvance,
                    amount: advanceBalance,
                    mode,
                    category: 'credit',
                    caseCode: caseCodeForAdvance,
                    payment_type: 'advance_adjustment',
                    instrument_number,
                    payment_date: date,
                    remarks: 'Amount covered by advance payment',
                },
            });

        } else {
            // If the total advance covers the entire payout, create a single advance adjustment payment
            await walletPaymentCreateAPI({
                data: {
                    agentId: agentIdForAdvance,
                    amount: ReceiptDue,
                    mode,
                    category: 'credit',
                    caseCode: caseCodeForAdvance,
                    payment_type: 'advance_adjustment',
                    instrument_number,
                    payment_date: date,
                    remarks: 'Full amount covered by advance payment',
                },
            });
        }
    } catch (error) {
        console.error('Error creating wallet payments:', error);
    }
};



  useEffect(() => {
    handlDueAmount();
    // matchAndPushAmount()
  }, [receiptValues]);
  // useEffect(()=>{
  //   // handlDueAmount()
  //   matchAndPushAmount()
  // },[])

  const handlDueAmount = () => {
    if (receiptValues.length > 0) {
      console.log("recet", receiptValues, totalCheckedPayOut, totalCheckedDue);
    }
  };

  // const matchAndPushAmount = () => {
  //   const updatedReceiptValues = receiptValues.map((receipt) => {
  //     const matchingPayment = recPayDue.find((payment) => payment.id === receipt.id);
  //     console.log('match',matchingPayment)
  //     if (matchingPayment) {
  //       return { ...receipt, DueAmount: matchingPayment.DueAmount };
  //     }
  //     return receipt;
  //   });

  //   const total = updatedReceiptValues.reduce((sum, receipt) => sum + receipt.DueAmount, 0);

  //   setReceiptValues(updatedReceiptValues);
  //   setTotalAmount(total);
  // };

  const ExportInExcel = useMemo(() => {
    if (!excelSearchResults) {
      return [];
    }

    const results = [];
    let totalGrossAmt = 0;
    excelSearchResults.forEach((caseInfo) => {
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const ngstCalc = caseInfo.companyId.newGSTCalc;
      const ugstCalc = caseInfo.companyId.usedGSTCalc;
      const loanCategory = caseInfo.meta.loanType;
      const DueAmount = getPayout(caseInfo, "Due");
      const payoutAmount = getPayout(caseInfo, "Payout");
      const GSTEncExc = getGSTCalc(DueAmount, ngstCalc, ugstCalc, loanCategory);
      const totalDuewithGST = totalDueGSTCalc(DueAmount, ngstCalc, ugstCalc, loanCategory);
      const agentName =
        caseInfo.agentId.personalInfo.firstName +
        " " +
        caseInfo.agentId.personalInfo.lastName +
        "-" +
        caseInfo.agentId.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      const difference = receiptAmount - paymentAmount;
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      // setGrossLoan(totalGrossAmt);
      const loanType =
        caseInfo.meta.loanType + " " + (caseInfo.meta?.usedCarType || "");
      const loanDate = new Date(caseInfo.meta.loanDate);
      const firsttEMI = new Date(caseInfo.meta.firstEMI);
      const lastEMI = new Date(caseInfo.meta.LastEMIDate);
      const disbursmentDate = new Date(caseInfo.meta.loanDate);
      const dateOptions = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      };
      const formattedLoanDate = loanDate.toLocaleDateString(
        "en-GB",
        dateOptions
      );
      const formattedFirstEMIDate = firsttEMI.toLocaleDateString(
        "en-GB",
        dateOptions
      );
      const formattedLastEMIDate = lastEMI.toLocaleDateString(
        "en-GB",
        dateOptions
      );
      const formattedDisbusmentDate = disbursmentDate.toLocaleDateString(
        "en-GB",
        dateOptions
      );
      const formattedDate = new Date(caseInfo.ts).toLocaleDateString(
        "en-GB",
        dateOptions
      );
      // const businessIRR = caseInfo.meta.businessIRR.toFixed(2);
      results.push({
        "Loan Date": formattedLoanDate,
        "Loan Type": loanType,
        // "Car Loan Type": caseInfo.meta.usedCarType,
        "Loan A/c/Policy Number": caseInfo.meta.LoanAccountNo,
        "Loan Amount": caseInfo.meta.loanAmount,
        "EMI Amount": caseInfo.meta.EMIAmount,
        Tenure: caseInfo.meta.tenure,
        ROI: caseInfo.meta.businessIRR,
        "Processing Fees": caseInfo.meta.processingFees,
        "Disbursed Amount": caseInfo.meta.disbursedAmount,
        "Dealer/Showroom": caseInfo.meta?.showroomDealer?.companyDisplayName,
        "First EMI": formattedFirstEMIDate,
        "Last EMI Date": formattedLastEMIDate,
        "Bank/Company Name": caseInfo.companyId.companyName,
        "Name of Customer": customerName,
        "Customer Mobile": caseInfo.customerId.phone,
        "Model Name": caseInfo.meta.vehicleProductId.productName,
        "Cost Of Asset": caseInfo.meta.costOfAsset,
        "Cross Sell Amount": CrossSellAmount,
        "Gross Loan Amount": caseInfo.meta.grossLoanAmount,
        "Advance EMI": caseInfo.meta.EMIAdvance,
        "Vehicle Number": caseInfo.meta.vehicleNumber,
        "Invoice Received": caseInfo.meta.invoiceRecv === true ? "YES" : "NO",
        "RC Received": caseInfo.meta.RCRecv === true ? "YES" : "NO",
        "Insurance Received":
          caseInfo.meta.insuranceRec === true ? "YES" : "NO",
        "Parivahan Status":
          caseInfo.meta.parivahanStatus === true ? "YES" : "NO",
        "RTO Slip Received": caseInfo.meta.rtoSlip === true ? "YES" : "NO",
        "Assigned Agent Name":
          caseInfo.agentId.personalInfo.firstName +
          " " +
          caseInfo.agentId.personalInfo.lastName,
        "Employment Type": caseInfo?.agentId?.employmentType || '',
        // // "Reporting Manager Name":
        //   caseInfo.reportingManagerId.personalInfo.firstName +
        //   " " +
        //   caseInfo.reportingManagerId.personalInfo.lastName +
        //   " " +
        //   caseInfo.reportingManagerId.personalInfo.phone,
        Amount: amount,
        "Bank Payment Rate": caseInfo.companyCommissionPercentage,
        "Due Amount": DueAmount,
        "Received Amount": receiptAmount,
        "GST(Inc/Exc)": GSTEncExc,
        "Total Due Amount(Inc/Exc GST)": totalDuewithGST,
        "Agent Payout Rate(%)": caseInfo.agentCommissionPercentage,
        "Payout Amount": payoutAmount,
        "Paid Amount": caseInfo.paymentAmount,
        "Disbursement Date": formattedDisbusmentDate,
        Saving: difference,
        "Created By": caseInfo.by.personalInfo.firstName,
        Date: formattedDate,
      });
    });

    return results;
  }, [
    excelSearchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
  ]);
  const viewRemarks = async (id) => {
    openAlertDialog("remarks");
    if (!id) return;

    let where = {
      refId: id,
      deleted: false,
      source: "cases",
    };

    const {
      data: {
        data: { data: remarks },
      },
    } = await remarkSearchAPI({
      where,
      sortBy: "ts",
      pageLength: 0,
      currentPage: 1,
      autopopulate: false,
    });
    setRemarksDetails(remarks);
  };
  const viewComission = async (id, callFromDueOrPay) => {
    openAlertDialog("Comission", callFromDueOrPay);
    if (!id) return;
    let caseId = { _id: id }
    const {
      data: {
        data: { data: caseForComission },
      },
    } = await caseSearchAPI({
      where: {
        ...caseId
      },
      autopopulate: true
    });

    setCaseForViewComission(caseForComission[0])
  };

  // EDIT
  const editClick = useCallback(
    (record) => {
      dispatch(caseEditAction(record));
      history.push(RoutingUtil.caseManagerUrl());
    },
    [dispatch, caseEditAction, history]
  );
  return (
    <div>
      <Formik
        onSubmit={onSearchSubmit}
        onClear={onClear}
        enableReinitialize
        initialValues={filterInitialValues}
      // validationSchema={}
      >
        {(formikProps) => (
          <RenderFilters
            // forceRefreshSearchContainer={forceRefreshSearchContainer}
            onClear={onClear}
            {...formikProps}
            invoiceInitialValues={invoiceInitialValues}
            activityList={activitiesFromSearch}
            userType={userType}
            ExportInExcel={ExportInExcel}
            handleChange={handleChange}
            generateInvoice={generateInvoice}
            handleReceipt={handleReceipt}
            handlePayment={handlePayment}
            history={history}
            onPageChange={onPageChange}
            alertModalClass={alertModalClass}
            alertDisplay={alertDisplay}
            openAlertDialog={openAlertDialog}
            closeAlertDialog={closeAlertDialog}
            dueAmountModalClass={dueAmountModalClass}
            dueAmountDisplay={dueAmountDisplay}
            payoutModalClass={payoutModalClass}
            payoutDisplay={payoutDisplay}
            comissionModalClass={comissionModalClass}
            comissionDisplay={comissionDisplay}
            viewRemarks={viewRemarks}
            viewComission={viewComission}
            editClick={editClick}
            totalPayout={totalPayout}
            totalDueAmount={totalDueAmount}
            paid={paid}
            netPaid={netPaid}
            received={received}
            netReceived={netReceived}
            grossLoan={grossLoan}
            netLoan={netLoan}
            totalCheckedDue={totalCheckedDue}
            totalCheckedPayOut={totalCheckedPayOut}
            totalAdvanceAmount={totalAdvanceAmount}
            remainingPayOut={remainingPayOut}
            pendingDueList={pendingDueList}
            pendingPayOutList={pendingPayOutList}
            caseForViewComission={caseForViewComission}
            callFrom={callFrom}
            total={total}
            handleSubmitUpdates={handleSubmitUpdates}
          />
        )}
      </Formik>

      {/* <div className={`modal fade ${(invoiceModal) ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> */}
      <div
        className={`modal fade ${remarksModalClass}`}
        id="authAlert"
        style={{
          display: `${remarksDisplay}`,
          overflowY: "scroll",
          opacity: "1",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                View Remarks
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeAlertDialog("remarks")}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group col-md-12">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Sr. No.</th>
                      <th scope="col">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {remarksDetails.map((remark, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{remark.text}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeAlertDialog("remarks")}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RptCaseStatus;
